import { useLang } from "@/lib/i18n";

export function Flag({ code, className = "h-4 w-6" }) {
  if (!code) return null;
  return (
    <img
      src={`https://flagcdn.com/w40/${code.toLowerCase()}.png`}
      alt={code}
      loading="lazy"
      className={`${className} shrink-0 rounded-sm border border-border object-cover`}
      data-testid={`flag-${code.toLowerCase()}`}
    />
  );
}

export function Activities({ items }) {
  const { t, L } = useLang();
  if (!items?.length) return null;
  return (
    <div className="mt-7">
      <p className="eyebrow mb-3">{t("jv_activities")}</p>
      <ul className="space-y-2">
        {items.map((a, i) => (
          <li key={i} className="flex gap-3 text-sm text-muted-foreground leading-relaxed">
            <span className="mt-[9px] h-1 w-1 shrink-0 rounded-full bg-primary" />
            <span>{L(a)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function PartnerNetwork({ names, testid }) {
  const { t } = useLang();
  if (!names?.length) return null;
  return (
    <div className="mt-7" data-testid={testid}>
      <p className="eyebrow mb-3">{t("jv_network")}</p>
      <div className="flex flex-wrap gap-2">
        {names.map((n) => (
          <span
            key={n}
            className="rounded-full border border-border bg-card/60 px-3.5 py-1.5 text-[11px] tracking-wide text-foreground/75 transition-colors hover:border-primary/60 hover:text-primary"
          >
            {n}
          </span>
        ))}
      </div>
    </div>
  );
}

export function VentureMeta({ venture }) {
  const { t } = useLang();
  return (
    <div className="mt-8 grid gap-5 border-t border-border pt-7 sm:grid-cols-3">
      <div>
        <p className="eyebrow mb-2">{t("jv_partner")}</p>
        <p className="flex items-center gap-2 text-sm" data-testid={`venture-partner-${venture.id}`}>
          <Flag code={venture.partner_code} />
          {venture.partner}
        </p>
      </div>
      <div>
        <p className="eyebrow mb-2">{t("jv_origin")}</p>
        <p className="text-sm">{venture.partner_origin}</p>
      </div>
      <div>
        <p className="eyebrow mb-2">{t("jv_region")}</p>
        <p className="text-sm">{venture.region}</p>
      </div>
    </div>
  );
}
